import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Modal from "react-modal";
import { toast } from "react-toastify";
import ModalHeadAndClose from "../../payouts-wtf/common/ModalHeadAndClose";
import CommonStructured from "../../common-components/CommonStructured";
import FetchUserDetails from "../FetchUserDetails";
import { fetchUserDetailsByMobileData } from "../../../redux/reducers/apiSlice";
import { validatemap_form_email } from "../../../exports/Validations";
import { registerUser } from "../../../redux/reducers/postApiSlice";
import PMForm from "./PMForm";
import { showConfirmAlert } from "../../components-react/ReactAlert";

const PMTopStructure = ({ decryptedText, isOpen, callFunction }) => {
  const dispatch = useDispatch();
  const { userDetailsByMobile } = useSelector((state) => state.api);

  const isAdmin = decryptedText?.account_type === "admin";

  const [showUserInfoForm, setShowUserInfoForm] = useState(false);
  const [paymentFormModal, setPaymentFormModal] = useState(false);
  const initialUserFormData = {
    mobile: "",
    email: "",
    name: "",
    gender: "",
    user_id: "",
    dob: "",
  };
  const [userFormData, setUserFormData] = useState(initialUserFormData);
  const [isUserExist, setIsUserExist] = useState(false);
  const [isFetchUserDetaillsByMobile, setIsFetchUserDetaillsByMobile] =
    useState(false);
  const [canCallRegister, setCanCallRegister] = useState(false);

  function handleBack() {
    setUserFormData(initialUserFormData);
    setIsUserExist(false);
    setIsFetchUserDetaillsByMobile(false);
  }

  const onClickFetchUserDetails = () => {
    const handleConfirm = () => {
      if (userFormData.mobile && userFormData.mobile?.length === 10) {
        dispatch(
          fetchUserDetailsByMobileData({
            userMobile: userFormData.mobile,
            token: decryptedText?.token,
          })
        );
        setIsFetchUserDetaillsByMobile(true);
      } else {
        toast.error("Please Enter Mobile Number! (Number Must Be 10 Digit)");
        setIsFetchUserDetaillsByMobile(false);
      }
    };

    showConfirmAlert(handleConfirm, `${userFormData.mobile} number`);
  };

  const onClickRegisterUser = () => {
    if (
      !userFormData.mobile ||
      !userFormData.email ||
      !userFormData.name ||
      !userFormData.gender?.value
    ) {
      toast.error("Please Ensure All The Fields Are Filled!");
    } else if (!validatemap_form_email(userFormData.email)) {
      toast.error("Please Enter Correct Format of Email!");
    } else if (userFormData.mobile?.length !== 10) {
      toast.error("Please Enter Correct Format of Mobile Number!");
    } else {
      setCanCallRegister(true);
    }
  };

  const handleRegisterUser = async (userData, TOKEN) => {
    setCanCallRegister(false);

    try {
      const actionResult = dispatch(registerUser({ userData, TOKEN }));
      const result = await actionResult;

      console.log("result=> ", result);

      if (result?.payload?.status && result.payload?.data) {
        // if (result.payload?.data) {
        //   setUserFormData({
        //     mobile: result.payload.data?.mobile,
        //     email: result.payload.data?.email,
        //     name: result.payload.data?.name,
        //     user_id: result.payload.data?.user_id,
        //   });
        // }
        setUserFormData({
          mobile: result.payload.data?.mobile,
          email: result.payload.data?.email,
          name: result.payload.data?.name,
          user_id: result.payload.data?.user_id,
        });

        setPaymentFormModal(true);
        setShowUserInfoForm(false);
        setIsUserExist(false);
      } else {
        const errorMessage = result?.error?.message || result?.payload?.message;
        toast.error(errorMessage);
      }
    } catch (error) {
      console.log("handleRegisterUser ERROR => ", error);
    }
  };

  useEffect(() => {
    if (canCallRegister) {
      // setUserFormData(initialUserFormData);

      const userData = {
        name: userFormData.name,
        mobile: userFormData.mobile,
        email: userFormData?.email,
        gender: userFormData.gender?.value,
        dob: userFormData.dob || "",

        is_web: 1,
        account_type: "member",
        otp: "otp",
        referral_code: "",
        n_token: "n_token",
      };

      handleRegisterUser(userData, decryptedText?.token);
    }
  }, [userFormData, canCallRegister]);

  useEffect(() => {
    if (paymentFormModal) {
      setShowUserInfoForm(false);
    }

    if (!showUserInfoForm && !paymentFormModal) {
      setUserFormData(initialUserFormData);
    }
  }, [paymentFormModal, showUserInfoForm]);

  useEffect(() => {
    if (isOpen) {
      setShowUserInfoForm(true);
    }
  }, []);

  useEffect(() => {
    if (isFetchUserDetaillsByMobile && userDetailsByMobile?.status) {
      const { uid, name, email, gym_id, gym_name, account_type } =
        userDetailsByMobile?.data?.[0];

      if (account_type !== "member") {
        toast.error("Enter Member Mobile Number!");
        return;
      } else if (!validatemap_form_email(email)) {
        toast.error("Member Email Is Not Valid! Please Update Email.");
        return;
      } else {
        setUserFormData({
          ...userFormData,
          name: name,
          email: email,
          gym_id: gym_id,
          gym_name: gym_name,
          user_id: uid,
        });
        setPaymentFormModal(true);
        setShowUserInfoForm(false);
        setIsUserExist(false);
        setCanCallRegister(false);
      }
    } else if (
      isFetchUserDetaillsByMobile &&
      userDetailsByMobile?.status === false
    ) {
      setIsUserExist(true);
      toast.error(userDetailsByMobile?.message);
    }
  }, [userDetailsByMobile]);

  return (
    <>
      <Modal
        isOpen={paymentFormModal}
        onRequestClose={() => {
          setPaymentFormModal(false);
          setUserFormData(initialUserFormData);
        }}
        contentLabel="Payment Link Modal"
        ariaHideApp={false}>
        <div className="createNewCTOModalContainer sendRenewalPaymentLinkModalContainer">
          <ModalHeadAndClose
            title="Create Payment Link"
            onClose={() => {
              setPaymentFormModal(false);
              setUserFormData(initialUserFormData);
            }}
          />

          <PMForm
            paymentLinkData={userFormData}
            closeModal={() => {
              setUserFormData(initialUserFormData);
              setPaymentFormModal(false);
            }}
            decryptedText={decryptedText}
            callFunction={callFunction}
          />
        </div>
      </Modal>

      {!isOpen ? (
        <CommonStructured
          pageHeading={"Partial Payments"}
          createBtnTxt={isAdmin ? "+ Create New Partial Payment Link" : null}
          onClickCreateBtn={() => (isAdmin ? setShowUserInfoForm(true) : null)}
          isReload={callFunction}
        />
      ) : null}

      {showUserInfoForm && (
        <FetchUserDetails
          isUserExist={isUserExist}
          userFormData={userFormData}
          setUserFormData={setUserFormData}
          onClickFetchUserDetails={onClickFetchUserDetails}
          onClickRegisterUser={onClickRegisterUser}
          handleBack={handleBack}
        />
      )}
    </>
  );
};

export default PMTopStructure;
